import Vue from 'vue'
import Router from 'vue-router'

import Index from '../view/Index'
import Login from '../view/login'
import ProjectList from '../view/ProjectList'
import All from '../view/All'
import DigitalGeneralDrawing from '../components/blockComponent/DigitalGeneralDrawing'

import {auth} from '../assets/js/auth';

Vue.use(Router)

const router = new Router({
    // mode: 'history',
    // base: process.env.BASE_URL,
    routes: [{
            path: '',
            redirect: '/login'
        },
        {
            path: '/login',
            component: Login
        },
        {
            path: '/index',
            name: 'Index',
            component: Index,
            children: [ //这里就是二级路由的配置

            ]
        },
        {
            path: '/plist',
            component: ProjectList
        },
        {
            path: '/all',
            component: All
        },
        {
            path: '/digital',
            component: DigitalGeneralDrawing
        },
    ]
})
router.beforeEach((to, from, next) => {
    // to 将要访问的路径
    // from 代表从哪个路径跳转而来
    // next 是一个函数，表示放行
    //     next()  放行    next('/login')  强制跳转
    if (to.path === '/login') return next()
    // 免登录
    if(to.query.user) {
        auth(to.query.user).then( (res) => {
            if(res === 'OK') {
                // 指定项目
                if(to.path === '/plist' && to.query.p) {
                    window.localStorage.setItem("project", to.query.p);
                    return next('/index')
                }
                if(to.path === '/all' && to.query.p) {
                    window.localStorage.setItem("project", to.query.p);
                    return next()
                }
                next()
            } else {
                return next('/login');
            }
        });
    } else {
        // 获取token
        let Token = window.localStorage.getItem("Token")
        if (!Token) return next('/login')
        next()
    }
})
export default router